export default "__VITE_ASSET__Bhdpf2Z8__"